import { render, staticRenderFns } from "./overlay-drawer-status-block.vue?vue&type=template&id=5bd22a0e"
import script from "./overlay-drawer-status-block.vue?vue&type=script&lang=js"
export * from "./overlay-drawer-status-block.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports